var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"file","accept":"video/mp4, video/x-m4v, video/*","capture":""},on:{"change":_vm.setvideo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }